export default "__VITE_ASSET__DB57xUfN__"